import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const LOGO_COLOR =
  "https://customer-assets.emergentagent.com/job_dd9fcd17-40f1-4372-98d5-220ac01e3675/artifacts/wrf3l981_QC4Health%20Colour.png";

const NAV_LINKS = [
  { to: "/product", label: "Product" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/resources", label: "Resources" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleBookDemo = () => {
    setOpen(false);
    navigate("/book-demo");
  };

  return (
    <header
      className="bg-black sticky top-0 z-50 border-b border-white/10"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="h-20 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3 group"
            data-testid="navbar-logo-link"
            onClick={() => setOpen(false)}
          >
            <img
              src={LOGO_COLOR}
              alt="QC4Health"
              className="h-12 w-auto select-none"
              draggable={false}
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors ${
                    isActive
                      ? "text-white"
                      : "text-white/70 hover:text-white"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <button
              onClick={handleBookDemo}
              data-testid="navbar-book-demo-btn"
              className="inline-flex items-center gap-2 bg-[#22A34A] hover:bg-[#1e9042] text-white rounded-full px-5 py-2.5 text-sm font-medium transition-all hover:-translate-y-0.5 shadow-[0_4px_14px_0_rgba(34,163,74,0.35)]"
            >
              Book a Demo
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>

          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((s) => !s)}
            aria-label="Toggle navigation"
            data-testid="navbar-mobile-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t border-white/10" data-testid="navbar-mobile-menu">
            <nav className="flex flex-col gap-1 pt-4">
              {NAV_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-lg text-base transition-colors ${
                      isActive
                        ? "text-white bg-white/5"
                        : "text-white/75 hover:text-white hover:bg-white/5"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <button
                onClick={handleBookDemo}
                data-testid="navbar-mobile-book-demo-btn"
                className="mt-4 inline-flex items-center justify-center gap-2 bg-[#22A34A] hover:bg-[#1e9042] text-white rounded-full px-5 py-3 text-sm font-medium transition-all"
              >
                Book a Demo
                <ArrowRight className="w-4 h-4" />
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
